import { render, staticRenderFns } from "./UsuarioConfiguracao.vue?vue&type=template&id=0102876d"
import script from "./UsuarioConfiguracao.vue?vue&type=script&lang=js"
export * from "./UsuarioConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports